/**
 * @generated SignedSource<<149e1ec489efda7822c5a7bc23172b92>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type subscriptionQuery$variables = Record<PropertyKey, never>;
export type subscriptionQuery$data = {
  readonly subscription: {
    readonly hasSidesPerVariant: boolean;
  } | null;
};
export type subscriptionQuery = {
  response: subscriptionQuery$data;
  variables: subscriptionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSidesPerVariant",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "subscriptionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "subscriptionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3d52d7aee8b45ea19a46c803edf60959",
    "id": null,
    "metadata": {},
    "name": "subscriptionQuery",
    "operationKind": "query",
    "text": "query subscriptionQuery {\n  subscription {\n    hasSidesPerVariant\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "11078d496a024dcd2fc78c90526eeb6d";

export default node;
